import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from "@angular/core";
import { Country, DirtyModel } from "@models";
import { Phone } from "@models/interfaces";
import { BpSelectOption } from "../bp-select/bp-select.component";

@Component({
	selector: "bp-input-phone",
	templateUrl: "./bp-input-phone.component.html",
	standalone: false
})
export class BpInputPhoneComponent implements OnInit, OnChanges {
	@Input()
	public model: DirtyModel;

	@Input()
	public field: string;

	@Input()
	public disabled: boolean;

	@Input()
	public error: boolean;

	@Input()
	public phoneCode: string;

	@Input()
	public countries: Country[] = [];

	@Output()
	public valueChange: EventEmitter<Phone> = new EventEmitter<Phone>();

	// Others
	public phoneNumber: string = "";
	public phoneCodeOptions: BpSelectOption[] = [];

	@Input()
	public countrySelected: Country = null;

	public ngOnInit(): void {
		this.initPhoneCodeOptions();
	}

	public ngOnChanges(changes: SimpleChanges): void {
		// the logic below gets triggered upon change of country selected and if the phone number input is not filled
		if (!this.phoneNumber && changes.countrySelected && this.countrySelected) {
			this.phoneCode = this.countrySelected.getPhoneCode().toString();
			this.update();
		}
	}

	public initPhoneCodeOptions(): void {
		this.phoneCodeOptions = this.countries.map((country) => ({
			name: " +" + country.getPhoneCode(),
			icon: "flag-icon flag-icon-" + country.getIso().toLowerCase(),
			value: country.getPhoneCode() + ""
		}));
	}

	public selectedCountryName(): string {
		const country: Country = this.countries.find((c) => c.getPhoneCode() + "" === this.phoneCode);
		if (country) {
			return " +" + country.getPhoneCode();
		}
		return "";
	}

	public onPhoneNumberChange(value: string): void {
		this.phoneNumber = value;
		this.update();
	}

	private update(): void {
		if (this.phoneCode && this.phoneNumber) {
			this.valueChange.emit({
				code: this.phoneCode,
				number: this.phoneNumber
			});
		}
	}
}
